
    import { Vue } from 'vue-class-component';
    export default class Services extends Vue {

    }
